var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL3EPriceLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 42,
    viewBox: "0 0 158 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_7845)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5753 -0.0195312C11.8738 -0.0195312 12.1723 -0.0195312 12.4707 -0.0195312C13.2305 0.0499881 13.9902 0.158515 14.7498 0.30605C13.8288 1.34544 12.8792 2.36288 11.9009 3.35838C11.668 3.34112 11.4374 3.30721 11.2091 3.25663C11.1226 3.21098 11.048 3.14993 10.9852 3.07349C10.7751 2.31507 10.6734 1.54181 10.68 0.753725C10.9347 0.526163 11.1789 0.281977 11.4125 0.0211664C11.4776 0.0320656 11.5319 0.0184997 11.5753 -0.0195312Z",
    fill: "#5FAB4E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.919,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4132 0.0197433C11.1796 0.280554 10.9354 0.52474 10.6807 0.752301C10.662 0.255478 10.9062 0.0112925 11.4132 0.0197433Z",
    fill: "#62AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7551 0.304688C14.85 0.331819 14.945 0.358951 15.04 0.386083C14.103 1.39079 13.167 2.39466 12.2318 3.39771C12.1233 3.38415 12.0148 3.37058 11.9062 3.35701C12.8845 2.36152 13.8341 1.34408 14.7551 0.304688Z",
    fill: "#5EAA52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0347 0.386719C15.5561 0.501775 16.0581 0.664566 16.5405 0.875091C15.6589 1.83806 14.7636 2.78768 13.8545 3.72393C13.3171 3.58961 12.7745 3.48108 12.2266 3.39835C13.1617 2.3953 14.0978 1.39142 15.0347 0.386719Z",
    fill: "#5CA954"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5454 0.875C16.7165 0.906345 16.8793 0.960608 17.0338 1.03779C16.8874 1.23207 16.7314 1.42199 16.5658 1.60756C15.8317 2.36192 15.1059 3.12161 14.3884 3.88663C14.1986 3.86312 14.0222 3.80885 13.8594 3.72384C14.7685 2.78759 15.6638 1.83797 16.5454 0.875Z",
    fill: "#5BA856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0282 1.03711C17.5807 1.27265 18.1233 1.5304 18.6561 1.81037C17.7739 2.73456 16.8922 3.65703 16.0107 4.57781C15.4747 4.32316 14.9321 4.09253 14.3828 3.88595C15.1003 3.12093 15.8261 2.36124 16.5601 1.60688C16.7257 1.42131 16.8817 1.23139 17.0282 1.03711Z",
    fill: "#59A659"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.661 1.81055C18.7981 1.89254 18.9337 1.97393 19.068 2.05473C18.2133 2.97722 17.3586 3.89969 16.504 4.82218C16.3283 4.76145 16.1655 4.68006 16.0156 4.57799C16.8971 3.65722 17.7788 2.73474 18.661 1.81055Z",
    fill: "#57A55C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.064 2.05469C19.7745 2.45379 20.4393 2.91503 21.0581 3.43841C20.2037 4.37425 19.3355 5.29671 18.4535 6.20585C17.8353 5.69587 17.1841 5.2346 16.5 4.82213C17.3547 3.89965 18.2093 2.97717 19.064 2.05469Z",
    fill: "#54A460"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0578 3.43945C21.1495 3.46484 21.2174 3.5191 21.2613 3.60224C20.3782 4.51245 19.5099 5.4349 18.6566 6.36969C18.5649 6.34429 18.497 6.29004 18.4531 6.2069C19.3351 5.29775 20.2033 4.3753 21.0578 3.43945Z",
    fill: "#53A364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2609 3.60156C21.4638 3.75031 21.6538 3.9131 21.8307 4.08993C20.9205 5.00006 20.0252 5.92251 19.1446 6.85738C18.9683 6.70814 18.8055 6.54535 18.6562 6.369C19.5096 5.43422 20.3778 4.51177 21.2609 3.60156Z",
    fill: "#52A165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8345 4.08984C22.1872 4.41543 22.5263 4.75456 22.8519 5.10729C21.9246 6.03959 21.0157 6.98919 20.1252 7.95612C19.8008 7.5909 19.4752 7.22462 19.1484 6.85729C20.029 5.92242 20.9244 4.99997 21.8345 4.08984Z",
    fill: "#50A068"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8517 5.10742C23.3892 5.71276 23.864 6.36392 24.2762 7.06091C23.339 8.03871 22.4029 9.01546 21.468 9.99114C21.0526 9.29098 20.6049 8.61271 20.125 7.95626C21.0155 6.98932 21.9244 6.03972 22.8517 5.10742Z",
    fill: "#4D9E6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33703 6.00269C7.73627 7.69844 6.13546 9.39415 4.5347 11.0899C4.30818 11.2553 4.09794 11.4452 3.90389 11.6597C3.86559 11.7503 3.81811 11.8317 3.76145 11.9039C2.51465 13.2321 1.25302 14.548 -0.0234375 15.8515C-0.0234375 14.5763 -0.0234375 13.3011 -0.0234375 12.0259C1.7018 10.2601 3.39754 8.46942 5.06377 6.65385C6.44656 6.17142 7.87098 5.95438 9.33703 6.00269Z",
    fill: "#5FAB4E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34139 6.00195C9.45152 6.00501 9.56006 6.01856 9.66697 6.04265C8.22766 7.53617 6.80324 9.04199 5.39371 10.5601C5.11599 10.7465 4.83111 10.9229 4.53906 11.0892C6.13982 9.39341 7.74063 7.6977 9.34139 6.00195Z",
    fill: "#5DAA52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66388 6.04297C10.255 6.07121 10.8383 6.15261 11.4139 6.28715C10.3286 7.44024 9.24335 8.59337 8.15807 9.74646C7.18613 9.85374 6.26363 10.1251 5.39062 10.5604C6.80015 9.04231 8.22457 7.53649 9.66388 6.04297Z",
    fill: "#5CA954"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4121 6.28711C11.5972 6.3263 11.7736 6.38059 11.9411 6.4499C10.8964 7.5218 9.86539 8.60704 8.84811 9.70571C8.61727 9.7163 8.38664 9.72985 8.15625 9.74641C9.24153 8.59332 10.3268 7.4402 11.4121 6.28711Z",
    fill: "#5BA856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9446 6.45117C12.5448 6.59687 13.1146 6.81391 13.6539 7.10233C12.7325 8.06443 11.81 9.02762 10.8864 9.99187C10.2206 9.81341 9.54228 9.71846 8.85156 9.70699C9.86884 8.60831 10.8998 7.52307 11.9446 6.45117Z",
    fill: "#59A659"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06377 6.6543C3.39754 8.46986 1.7018 10.2606 -0.0234375 12.0264C-0.0234375 11.6737 -0.0234375 11.321 -0.0234375 10.9683C1.07556 9.84211 2.16083 8.70257 3.23238 7.54965C3.8127 7.19847 4.42315 6.90003 5.06377 6.6543Z",
    fill: "#62AD49"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2769 7.06055C24.3865 7.19794 24.4815 7.34718 24.5618 7.50822C23.6005 8.46958 22.6509 9.44633 21.7129 10.4385C21.6007 10.3091 21.5193 10.1599 21.4688 9.99078C22.4037 9.01509 23.3397 8.03835 24.2769 7.06055Z",
    fill: "#4B9C71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6503 7.10156C13.8045 7.15834 13.9537 7.22618 14.0979 7.30505C13.1877 8.24236 12.2923 9.192 11.4119 10.1539C11.233 10.1058 11.0566 10.0515 10.8828 9.9911C11.8064 9.02685 12.7289 8.06366 13.6503 7.10156Z",
    fill: "#57A55C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1001 7.30469C14.8302 7.67614 15.495 8.13736 16.0943 8.68841C15.2383 9.57147 14.3972 10.4668 13.571 11.3745C12.9061 10.8724 12.1872 10.4654 11.4141 10.1535C12.2945 9.19164 13.1899 8.242 14.1001 7.30469Z",
    fill: "#54A460"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5598 7.50781C24.6483 7.63052 24.7161 7.7662 24.7633 7.91479C23.8272 8.91868 22.8912 9.92253 21.9551 10.9264C21.8531 10.7766 21.7717 10.6138 21.7109 10.438C22.6489 9.44592 23.5985 8.46917 24.5598 7.50781Z",
    fill: "#4A9C72"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23238 7.54883C2.16083 8.70175 1.07556 9.84129 -0.0234375 10.9674C-0.0234375 10.886 -0.0234375 10.8046 -0.0234375 10.7232C0.0316365 10.4769 0.133381 10.2464 0.281795 10.0314C1.12577 9.03083 2.1093 8.20333 3.23238 7.54883Z",
    fill: "#64AE48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7613 7.91602C24.9933 8.27159 25.1832 8.65142 25.331 9.05555C24.3814 10.073 23.4318 11.0904 22.4822 12.1079C22.3144 11.7142 22.1381 11.3208 21.9531 10.9276C22.8892 9.92375 23.8252 8.9199 24.7613 7.91602Z",
    fill: "#489B74"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5225 9.21713C85.2225 10.0764 84.9377 10.9446 84.6678 11.8218C83.8404 12.1288 83.1282 11.9525 82.5312 11.2927C82.1674 10.7247 82.086 10.1142 82.287 9.46132C82.7164 8.59205 83.4148 8.23257 84.3829 8.38283C84.8856 8.49947 85.2653 8.77755 85.5225 9.21713Z",
    fill: "#58A65A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0397 9.29853C91.7524 10.1203 91.481 10.9478 91.2258 11.7811C90.3772 12.1402 89.6378 11.9774 89.0078 11.2927C88.6439 10.7247 88.5625 10.1142 88.7636 9.46132C89.1929 8.59205 89.8913 8.23257 90.8595 8.38283C91.3922 8.51619 91.7858 8.82143 92.0397 9.29853Z",
    fill: "#54A362"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0936 8.68945C16.1851 8.71306 16.2529 8.76731 16.2971 8.85224C15.433 9.72619 14.5784 10.608 13.7331 11.4976C13.6556 11.4879 13.6013 11.4472 13.5703 11.3755C14.3965 10.4679 15.2376 9.57251 16.0936 8.68945Z",
    fill: "#53A364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2983 8.85156C16.4757 9.01549 16.6521 9.17828 16.8274 9.33993C15.9544 10.218 15.0997 11.1133 14.2634 12.026C14.0735 11.8632 13.8972 11.6868 13.7344 11.4969C14.5797 10.6073 15.4343 9.7255 16.2983 8.85156Z",
    fill: "#52A165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3332 9.05469C25.6411 9.7203 25.8852 10.4122 26.0658 11.1303C25.4687 11.7273 24.8854 12.3378 24.3158 12.9617C23.8543 12.9685 23.3931 12.9617 22.932 12.9413C22.8456 12.8957 22.771 12.8346 22.7082 12.7582C22.6212 12.5447 22.5466 12.3277 22.4844 12.107C23.434 11.0896 24.3836 10.0721 25.3332 9.05469Z",
    fill: "#469A78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5265 9.21875C85.8887 9.95066 85.8411 10.6561 85.3841 11.335C85.1843 11.5555 84.947 11.7183 84.6719 11.8234C84.9417 10.9462 85.2266 10.078 85.5265 9.21875Z",
    fill: "#57A65C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.787,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0534 9.29883C51.0143 9.43065 50.9598 9.55274 50.8906 9.66511C50.8906 9.54301 50.8906 9.42092 50.8906 9.29883C50.9448 9.29883 50.9993 9.29883 51.0534 9.29883Z",
    fill: "#71B733"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0534 9.29883C51.9622 9.29883 52.8714 9.29883 53.7802 9.29883C52.8242 12.2213 51.8609 15.138 50.8906 18.0488C50.8906 15.2542 50.8906 12.4597 50.8906 9.66511C50.9598 9.55274 51.0143 9.43065 51.0534 9.29883Z",
    fill: "#6FB635"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7802 9.29883C54.1928 9.77072 54.586 10.2591 54.9604 10.7639C53.6039 14.8473 52.2471 18.9306 50.8906 23.0139C50.8906 21.3589 50.8906 19.7039 50.8906 18.0488C51.8609 15.138 52.8242 12.2213 53.7802 9.29883Z",
    fill: "#6DB537"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.947,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0841 9.29883C68.855 10.0274 68.6108 10.7463 68.3516 11.4558C68.3516 10.7368 68.3516 10.0178 68.3516 9.29883C68.5957 9.29883 68.8399 9.29883 69.0841 9.29883Z",
    fill: "#64AE48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0841 9.29883C69.6266 9.29883 70.1695 9.29883 70.712 9.29883C69.9404 11.6817 69.1537 14.0557 68.3516 16.4209C68.3516 14.7659 68.3516 13.1109 68.3516 11.4558C68.6108 10.7463 68.855 10.0274 69.0841 9.29883Z",
    fill: "#62AD49"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7095 9.29883C71.103 9.29883 71.4962 9.29883 71.8897 9.29883C71.8897 14.2639 71.8897 19.2291 71.8897 24.1942C70.8409 27.2727 69.8235 30.3657 68.8374 33.4732C67.4008 31.6971 65.9625 29.92 64.5234 28.1419C64.9577 26.8531 65.3915 25.5643 65.8258 24.2756C66.6658 25.2853 67.5001 26.3028 68.3287 27.3279C68.349 23.6923 68.3559 20.0566 68.349 16.4209C69.1512 14.0557 69.9379 11.6817 70.7095 9.29883Z",
    fill: "#60AB4E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0405 9.29883C92.358 10.0083 92.2969 10.6866 91.8574 11.3337C91.6771 11.5287 91.4667 11.6779 91.2266 11.7814C91.4817 10.9481 91.7532 10.1206 92.0405 9.29883Z",
    fill: "#52A264"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4944 9.29883C97.1525 10.3113 96.8269 11.3287 96.5176 12.3512C96.4362 12.3512 96.3548 12.3512 96.2734 12.3512C96.2734 11.3337 96.2734 10.3163 96.2734 9.29883C96.6804 9.29883 97.0874 9.29883 97.4944 9.29883Z",
    fill: "#4FA069"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4924 9.29883C99.3103 9.29883 101.128 9.29883 102.946 9.29883C102.62 10.3162 102.295 11.3337 101.969 12.3512C100.151 12.3512 98.3336 12.3512 96.5156 12.3512C96.8249 11.3287 97.1505 10.3113 97.4924 9.29883Z",
    fill: "#4D9E6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.945 9.29883C103.312 9.29883 103.678 9.29883 104.044 9.29883C103.735 10.3219 103.409 11.3393 103.068 12.3512C102.701 12.3512 102.335 12.3512 101.969 12.3512C102.294 11.3337 102.62 10.3162 102.945 9.29883Z",
    fill: "#4B9D71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.047 9.29883C104.413 9.29883 104.78 9.29883 105.146 9.29883C104.837 10.3213 104.511 11.3387 104.169 12.3512C103.803 12.3512 103.437 12.3512 103.07 12.3512C103.412 11.3393 103.738 10.3219 104.047 9.29883Z",
    fill: "#4A9C72"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.141 9.29883C106.05 9.29883 106.959 9.29883 107.868 9.29883C106.813 12.6099 105.728 15.9064 104.612 19.1884C104.612 16.9093 104.612 14.6302 104.612 12.3512C104.462 12.3512 104.313 12.3512 104.164 12.3512C104.506 11.3387 104.832 10.3213 105.141 9.29883Z",
    fill: "#489B75"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.873 9.29883C109.338 9.29883 110.803 9.29883 112.268 9.29883C111.926 10.3113 111.601 11.3287 111.292 12.3512C110.233 12.3512 109.175 12.3512 108.117 12.3512C108.117 15.5934 108.117 18.8356 108.117 22.0779C106.95 25.5915 105.784 29.105 104.617 32.6186C104.617 28.1419 104.617 23.6651 104.617 19.1884C105.734 15.9064 106.819 12.6099 107.873 9.29883Z",
    fill: "#459979"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.266 9.29883C112.442 9.29883 112.619 9.29883 112.795 9.29883C112.469 10.3163 112.144 11.3338 111.818 12.3512C111.642 12.3512 111.465 12.3512 111.289 12.3512C111.598 11.3287 111.924 10.3113 112.266 9.29883Z",
    fill: "#44997B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.797 9.29883C114.018 9.29883 115.239 9.29883 116.46 9.29883C116.46 10.3163 116.46 11.3337 116.46 12.3512C114.913 12.3512 113.367 12.3512 111.82 12.3512C112.146 11.3338 112.471 10.3163 112.797 9.29883Z",
    fill: "#42977E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8296 9.33984C17.1705 9.68341 17.4826 10.0497 17.7656 10.4387C16.9122 11.3464 16.044 12.2418 15.161 13.1247C14.8922 12.7377 14.5937 12.3714 14.2656 12.0259C15.1019 11.1132 15.9565 10.2179 16.8296 9.33984Z",
    fill: "#50A068"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7609 10.4395C18.2743 11.0993 18.6948 11.8182 19.0225 12.5964C18.0741 13.5991 17.111 14.5894 16.133 15.5674C15.9424 14.6969 15.6169 13.8829 15.1562 13.1255C16.0393 12.2425 16.9075 11.3472 17.7609 10.4395Z",
    fill: "#4C9E6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9604 10.7637C55.8834 11.8769 56.7926 13.0028 57.6871 14.1416C57.2472 15.4249 56.8134 16.7137 56.3848 18.0079C55.7503 17.2169 55.1061 16.4301 54.4517 15.6474C54.4313 18.4691 54.4244 21.2908 54.4313 24.1125C53.3561 27.2862 52.3114 30.4742 51.2976 33.6765C51.1621 33.6765 51.0261 33.6765 50.8906 33.6765C50.8906 30.1222 50.8906 26.5679 50.8906 23.0137C52.2471 18.9304 53.6039 14.847 54.9604 10.7637Z",
    fill: "#6BB33B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0703 11.1309C26.0975 11.2123 26.1246 11.2937 26.1517 11.375C25.636 11.8907 25.1341 12.4198 24.6459 12.9623C24.5374 12.9623 24.4289 12.9623 24.3203 12.9623C24.8899 12.3384 25.4733 11.7279 26.0703 11.1309Z",
    fill: "#44997B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1464 11.375C26.2318 11.7785 26.2996 12.1855 26.3499 12.5959C26.3601 12.7588 26.2923 12.8741 26.1464 12.9419C25.6447 12.9622 25.1428 12.969 24.6406 12.9622C25.1288 12.4198 25.6308 11.8907 26.1464 11.375Z",
    fill: "#43987D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76145 11.9043C3.72785 12.0523 3.70072 12.2015 3.68005 12.352C2.44556 13.6272 1.21106 14.9024 -0.0234375 16.1776C-0.0234375 16.069 -0.0234375 15.9605 -0.0234375 15.852C1.25302 14.5484 2.51465 13.2325 3.76145 11.9043Z",
    fill: "#5DAA51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 12.3516C3.68005 13.0434 3.68005 13.7353 3.68005 14.4271C2.45494 15.7237 1.22044 17.0125 -0.0234375 18.2934C-0.0234375 17.588 -0.0234375 16.8826 -0.0234375 16.1771C1.21106 14.902 2.44556 13.6267 3.68005 12.3516Z",
    fill: "#5CA954"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0223 12.5957C19.111 12.7464 19.1788 12.9092 19.2258 13.0841C18.2219 14.1287 17.2181 15.1732 16.2142 16.2178C16.2047 15.9983 16.1776 15.7812 16.1328 15.5666C17.1108 14.5887 18.0739 13.5984 19.0223 12.5957Z",
    fill: "#4B9D71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2304 13.084C19.3134 13.2373 19.3812 13.4 19.4339 13.5724C18.3893 14.6576 17.3447 15.7429 16.3001 16.8282C16.273 16.6247 16.2459 16.4212 16.2188 16.2177C17.2226 15.1731 18.2265 14.1286 19.2304 13.084Z",
    fill: "#4A9C72"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4306 13.5723C19.5719 14.0154 19.694 14.4631 19.7969 14.9153C18.6302 16.1227 17.4636 17.33 16.2969 18.5374C16.2969 17.9676 16.2969 17.3978 16.2969 16.8281C17.3415 15.7428 18.386 14.6576 19.4306 13.5723Z",
    fill: "#489B74"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6851 14.1426C57.9619 14.4518 58.2199 14.7773 58.4584 15.1193C58.0062 16.3976 57.572 17.6864 57.1561 18.9856C56.8989 18.6616 56.6408 18.336 56.3828 18.0089C56.8114 16.7147 57.2452 15.4259 57.6851 14.1426Z",
    fill: "#6AB23E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 14.4277C3.68005 14.6584 3.68005 14.889 3.68005 15.1196C2.46039 16.4207 1.22589 17.7095 -0.0234375 18.9859C-0.0234375 18.7552 -0.0234375 18.5246 -0.0234375 18.294C1.22044 17.0131 2.45494 15.7243 3.68005 14.4277Z",
    fill: "#5BA856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7969 14.916C19.9553 15.7631 20.0231 16.6177 20.0004 17.48C18.7565 18.7609 17.522 20.0497 16.2969 21.3462C16.2969 20.4102 16.2969 19.4742 16.2969 18.5381C17.4636 17.3307 18.6302 16.1234 19.7969 14.916Z",
    fill: "#469979"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.755 15.0782C126.468 16.0496 126.156 17.0127 125.819 17.9677C124.207 17.8778 122.661 18.1491 121.18 18.7817C121.562 17.6471 121.929 16.5076 122.279 15.3631C123.756 15.0522 125.249 14.9572 126.755 15.0782Z",
    fill: "#3A928C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.61 15.1195C148.289 16.0802 147.978 17.0433 147.674 18.009C146.411 17.9684 145.231 18.2533 144.133 18.8637C144.526 17.6427 144.919 16.4218 145.313 15.2009C145.642 15.124 145.981 15.0765 146.33 15.0584C147.093 15.0192 147.853 15.0396 148.61 15.1195Z",
    fill: "#2A87A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.756 15.0781C126.94 15.0938 127.116 15.1209 127.285 15.1595C126.966 16.1195 126.653 17.0827 126.349 18.0491C126.171 18.0278 125.994 18.0006 125.82 17.9677C126.157 17.0126 126.469 16.0495 126.756 15.0781Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 15.1191C3.68005 15.9331 3.68005 16.747 3.68005 17.561C2.45494 18.8575 1.22044 20.1463 -0.0234375 21.4273C-0.0234375 20.6133 -0.0234375 19.7994 -0.0234375 18.9854C1.22589 17.709 2.46039 16.4202 3.68005 15.1191Z",
    fill: "#59A659"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4586 15.1191C59.6396 16.5443 60.806 17.9823 61.9586 19.4331C61.5093 20.713 61.075 22.0018 60.6563 23.2994C59.4752 21.8742 58.3088 20.4362 57.1562 18.9854C57.5722 17.6862 58.0064 16.3974 58.4586 15.1191Z",
    fill: "#67B141"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.608 15.1191C149.888 15.2634 151.082 15.6636 152.189 16.3197C152.466 16.4953 152.724 16.692 152.963 16.9098C152.665 17.7883 152.367 18.6701 152.067 19.5552C150.801 18.4998 149.336 17.9843 147.672 18.0087C147.976 17.043 148.288 16.0798 148.608 15.1191Z",
    fill: "#2785AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.28 15.1602C127.981 15.2336 128.659 15.3964 129.315 15.6485C128.988 16.6841 128.649 17.7151 128.297 18.7416C127.699 18.3659 127.048 18.1353 126.344 18.0497C126.648 17.0834 126.96 16.1202 127.28 15.1602Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1097 15.1998C25.0789 16.312 24.0343 17.4109 22.976 18.4963C22.9564 17.421 22.9767 16.3493 23.037 15.2812C23.0675 15.2557 23.1015 15.2354 23.1388 15.2202C24.129 15.1998 25.1193 15.193 26.1097 15.1998Z",
    fill: "#409681"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1103 15.2012C26.2188 15.2012 26.3273 15.2012 26.4359 15.2012C25.3114 16.4478 24.1583 17.6687 22.9766 18.864C22.9766 18.7419 22.9766 18.6198 22.9766 18.4977C24.0349 17.4122 25.0795 16.3134 26.1103 15.2012Z",
    fill: "#409683"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4359 15.2012C26.6665 15.2012 26.8971 15.2012 27.1277 15.2012C25.7429 16.6538 24.3591 18.1054 22.9766 19.5558C22.9766 19.3252 22.9766 19.0946 22.9766 18.864C24.1583 17.6687 25.3114 16.4478 26.4359 15.2012Z",
    fill: "#3F9584"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1277 15.2012C27.901 15.2012 28.6742 15.2012 29.4475 15.2012C27.316 17.4819 25.159 19.7338 22.9766 21.957C22.9766 21.1566 22.9766 20.3562 22.9766 19.5558C24.3591 18.1054 25.7429 16.6538 27.1277 15.2012Z",
    fill: "#3D9387"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4475 15.2012C30.3293 15.2012 31.211 15.2012 32.0928 15.2012C30.9669 16.395 29.8409 17.5888 28.7149 18.7826C28.1179 18.7758 27.521 18.7826 26.9242 18.8029C26.8498 18.814 26.7888 18.848 26.7411 18.9047C26.6818 19.5801 26.6615 20.2584 26.6801 20.9395C25.4456 22.2147 24.211 23.4899 22.9766 24.7651C22.9766 23.8291 22.9766 22.893 22.9766 21.957C25.159 19.7338 27.316 17.4819 29.4475 15.2012Z",
    fill: "#3A918C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0888 15.2012C32.1974 15.2012 32.3059 15.2012 32.4144 15.2012C31.2884 16.395 30.1625 17.5888 29.0365 18.7826C28.928 18.7826 28.8195 18.7826 28.7109 18.7826C29.8369 17.5888 30.9629 16.395 32.0888 15.2012Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.417 15.2012C32.8646 15.2012 33.3123 15.2012 33.76 15.2012C32.634 16.395 31.5081 17.5888 30.3821 18.7826C29.9344 18.7826 29.4867 18.7826 29.0391 18.7826C30.165 17.5888 31.291 16.395 32.417 15.2012Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7607 15.1998C33.9782 15.193 34.1952 15.1998 34.4119 15.2201C34.4492 15.2354 34.4831 15.2557 34.5136 15.2812C34.5714 15.5478 34.5918 15.819 34.5747 16.0951C33.7212 16.9894 32.8665 17.8848 32.0107 18.7812C31.4681 18.7812 30.9254 18.7812 30.3828 18.7812C31.5088 17.5874 32.6347 16.3936 33.7607 15.1998Z",
    fill: "#358E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6065 15.2012C78.6052 15.3402 78.5645 15.4623 78.4844 15.5675C78.4844 15.4454 78.4844 15.3233 78.4844 15.2012C78.5251 15.2012 78.5658 15.2012 78.6065 15.2012Z",
    fill: "#5BA856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6065 15.2012C78.9727 15.2012 79.339 15.2012 79.7053 15.2012C79.3215 16.4341 78.9145 17.655 78.4844 18.864C78.4844 17.7651 78.4844 16.6663 78.4844 15.5675C78.5645 15.4623 78.6052 15.3402 78.6065 15.2012Z",
    fill: "#5BA856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7079 15.2012C80.427 15.2012 81.1458 15.2012 81.8649 15.2012C81.8649 16.9512 81.8649 18.7012 81.8649 20.4512C80.9016 23.3543 79.9387 26.2574 78.9753 29.1605C78.6966 28.3023 78.5407 27.4205 78.5073 26.5151C78.487 23.9648 78.4801 21.4144 78.487 18.864C78.9172 17.655 79.3241 16.4341 79.7079 15.2012Z",
    fill: "#58A65A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5351 15.2012C94.5628 18.2944 93.5588 21.3738 92.5234 24.4395C92.5234 21.3601 92.5234 18.2806 92.5234 15.2012C93.5274 15.2012 94.5311 15.2012 95.5351 15.2012Z",
    fill: "#4FA069"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5402 15.2012C95.6622 15.2012 95.7843 15.2012 95.9064 15.2012C95.9064 20.4647 95.9064 25.7283 95.9064 30.9919C95.5686 31.8701 95.2699 32.7655 95.0111 33.6779C94.2378 33.6779 93.4646 33.6779 92.6913 33.6779C92.6982 32.7824 92.6913 31.8871 92.671 30.9919C91.9018 32.0531 90.9047 32.8128 89.6797 33.2709C90.092 31.9526 90.5124 30.6367 90.9413 29.3233C91.7756 28.4 92.2709 27.3147 92.4268 26.0674C92.4895 25.5265 92.5236 24.9839 92.5285 24.4395C93.5639 21.3738 94.5679 18.2944 95.5402 15.2012Z",
    fill: "#4D9F6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.308 15.2012C144.914 16.4221 144.521 17.643 144.128 18.864C142.459 19.8512 141.517 21.3164 141.299 23.2593C141.194 24.3077 141.323 25.3252 141.686 26.3116C141.251 27.6275 140.818 28.9434 140.383 30.2593C139.912 29.8308 139.519 29.3425 139.203 28.7942C140.643 24.4349 142.067 20.0667 143.476 15.6895C144.061 15.4451 144.671 15.2823 145.308 15.2012Z",
    fill: "#2C88A3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.235 15.2012C157.235 17.5481 157.235 19.895 157.235 22.2419C156.087 25.6851 154.948 29.1308 153.816 32.5791C153.858 31.7656 153.865 30.9516 153.836 30.1372C152.617 31.497 151.104 32.3584 149.299 32.7215C148.962 32.7861 148.622 32.8336 148.281 32.864C148.62 31.8336 148.959 30.8026 149.299 29.7709C151.802 29.1466 153.314 27.573 153.836 25.05C154.149 23.1399 153.695 21.4442 152.473 19.9628C152.795 19.0795 153.093 18.1841 153.368 17.2768C153.599 17.4733 153.809 17.6904 153.999 17.9279C154.02 17.0191 154.027 16.1102 154.02 15.2012C155.091 15.2012 156.163 15.2012 157.235 15.2012Z",
    fill: "#2382B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.28 15.3633C121.93 16.5078 121.564 17.6474 121.181 18.7819C120.499 19.089 119.861 19.4689 119.268 19.9214C118.784 19.102 118.309 18.2745 117.844 17.4389C118.126 17.1637 118.438 16.9263 118.78 16.7267C119.88 16.1 121.047 15.6455 122.28 15.3633Z",
    fill: "#3C9387"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.314 15.6484C130.184 15.974 130.943 16.4624 131.593 17.1136C131.056 18.6706 130.527 20.2307 130.006 21.7938C129.91 20.5021 129.34 19.4847 128.297 18.7415C128.649 17.715 128.988 16.684 129.314 15.6484Z",
    fill: "#358E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.477 15.6895C142.067 20.0666 140.643 24.4348 139.203 28.7941C138.777 28.1686 138.452 27.4903 138.227 26.7592C139.349 23.4204 140.447 20.0696 141.523 16.7069C142.114 16.2621 142.765 15.9229 143.477 15.6895Z",
    fill: "#2D89A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5718 16.0957C34.5912 16.9677 34.5709 17.8359 34.5107 18.7004C34.4802 18.7258 34.4463 18.7462 34.409 18.7614C33.6087 18.7817 32.8083 18.7885 32.0078 18.7817C32.8636 17.8853 33.7183 16.99 34.5718 16.0957Z",
    fill: "#338D97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.529 16.707C140.453 20.0697 139.355 23.4205 138.233 26.7594C137.752 24.9169 137.745 23.0719 138.212 21.2245C138.804 19.3341 139.909 17.8283 141.529 16.707Z",
    fill: "#2E89A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.966 16.9102C153.127 17.0033 153.262 17.1254 153.373 17.2764C153.098 18.1838 152.799 19.0791 152.477 19.9625C152.328 19.8404 152.192 19.7047 152.07 19.5555C152.37 18.6705 152.668 17.7887 152.966 16.9102Z",
    fill: "#2584AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.594 17.1133C132.367 17.9122 132.876 18.8618 133.12 19.9621C133.241 20.485 133.323 21.0141 133.364 21.5493C133.385 22.7023 133.392 23.8555 133.385 25.0086C132.42 27.8892 131.47 30.7787 130.536 33.6772C130.427 33.6772 130.319 33.6772 130.21 33.6772C130.217 32.8903 130.21 32.1035 130.19 31.3168C129.468 32.3061 128.525 33.0048 127.362 33.4127C126.964 33.5529 126.557 33.6546 126.141 33.7179C126.439 32.7819 126.738 31.8458 127.036 30.9098C128.41 30.3835 129.394 29.4474 129.987 28.1017C130.007 27.22 130.014 26.3382 130.007 25.4563C129.613 25.4563 129.22 25.4563 128.827 25.4563C129.101 24.6477 129.359 23.8337 129.6 23.0144C129.735 23.0144 129.871 23.0144 130.007 23.0144C130.007 22.6075 130.007 22.2005 130.007 21.7935C130.528 20.2304 131.057 18.6703 131.594 17.1133Z",
    fill: "#338D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 17.4805C20.0004 17.6026 20.0004 17.7247 20.0004 17.8467C18.7659 19.1219 17.5314 20.3971 16.2969 21.6723C16.2969 21.5638 16.2969 21.4553 16.2969 21.3467C17.522 20.0502 18.7565 18.7614 20.0004 17.4805Z",
    fill: "#44997B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 17.5605C3.68005 17.7912 3.68005 18.0218 3.68005 18.2524C2.46039 19.5535 1.22589 20.8423 -0.0234375 22.1187C-0.0234375 21.8881 -0.0234375 21.6575 -0.0234375 21.4268C1.22044 20.1459 2.45494 18.8571 3.68005 17.5605Z",
    fill: "#57A55C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 17.8457C20.0004 19.1209 20.0004 20.3961 20.0004 21.6713C18.7659 22.9465 17.5314 24.2217 16.2969 25.4969C16.2969 24.2217 16.2969 22.9465 16.2969 21.6713C17.5314 20.3961 18.7659 19.1209 20.0004 17.8457Z",
    fill: "#41977F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 18.252C3.68005 19.4186 3.68005 20.5853 3.68005 21.752C2.44556 23.0271 1.21106 24.3024 -0.0234375 25.5775C-0.0234375 24.4244 -0.0234375 23.2713 -0.0234375 22.1182C1.22589 20.8418 2.46039 19.5531 3.68005 18.252Z",
    fill: "#54A460"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9586 19.4336C62.6118 20.2222 63.2491 21.0226 63.8714 21.8348C63.4668 23.1427 63.0464 24.4451 62.6097 25.7417C61.9435 24.9397 61.2924 24.1258 60.6562 23.2999C61.075 22.0023 61.5093 20.7135 61.9586 19.4336Z",
    fill: "#65AF46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8661 20.4512C81.8661 21.55 81.8661 22.6488 81.8661 23.7477C81.0884 26.0128 80.3424 28.2918 79.6277 30.5849C79.3347 30.1481 79.1178 29.6733 78.9766 29.1605C79.9399 26.2574 80.9028 23.3543 81.8661 20.4512Z",
    fill: "#57A55C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6801 20.9395C26.6801 21.048 26.6801 21.1565 26.6801 21.265C25.4436 22.5422 24.2091 23.8173 22.9766 25.0906C22.9766 24.9821 22.9766 24.8736 22.9766 24.765C24.211 23.4899 25.4456 22.2146 26.6801 20.9395Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6801 21.2637C26.6801 21.7249 26.6801 22.1862 26.6801 22.6474C25.4604 23.9485 24.2259 25.2373 22.9766 26.5137C22.9766 26.0389 22.9766 25.5641 22.9766 25.0893C24.2091 23.816 25.4436 22.5408 26.6801 21.2637Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 21.6719C20.0004 21.7804 20.0004 21.8889 20.0004 21.9975C18.7807 23.2986 17.5462 24.5873 16.2969 25.8637C16.2969 25.7416 16.2969 25.6195 16.2969 25.4975C17.5314 24.2223 18.7659 22.9471 20.0004 21.6719Z",
    fill: "#409683"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 21.752C3.68005 21.8605 3.68005 21.969 3.68005 22.0775C2.46039 23.3786 1.22589 24.6674 -0.0234375 25.9438C-0.0234375 25.8217 -0.0234375 25.6996 -0.0234375 25.5775C1.21106 24.3024 2.44556 23.0271 3.68005 21.752Z",
    fill: "#53A364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8788 21.834C64.1674 22.1359 64.425 22.4615 64.6521 22.8107C64.2475 24.1187 63.8271 25.421 63.3904 26.7177C63.1332 26.3937 62.8752 26.0681 62.6172 25.741C63.0539 24.4443 63.4743 23.142 63.8788 21.834Z",
    fill: "#64AE48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 21.998C20.0004 22.2287 20.0004 22.4593 20.0004 22.6899C18.7807 23.991 17.5462 25.2798 16.2969 26.5562C16.2969 26.3256 16.2969 26.095 16.2969 25.8643C17.5462 24.5879 18.7807 23.2992 20.0004 21.998Z",
    fill: "#3F9584"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 22.0781C3.68005 22.4309 3.68005 22.7835 3.68005 23.1363C2.43072 24.4127 1.19623 25.7014 -0.0234375 27.0025C-0.0234375 26.6498 -0.0234375 26.2971 -0.0234375 25.9444C1.22589 24.668 2.46039 23.3792 3.68005 22.0781Z",
    fill: "#52A165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.117 22.0781C108.117 22.6343 108.117 23.1905 108.117 23.7467C107.003 27.048 105.904 30.3581 104.821 33.677C104.753 33.677 104.685 33.677 104.617 33.677C104.617 33.3242 104.617 32.9716 104.617 32.6188C105.784 29.1053 106.95 25.5917 108.117 22.0781Z",
    fill: "#44997B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.237 22.2422C157.237 24.4806 157.237 26.7189 157.237 28.9573C156.131 32.3016 155.033 35.6524 153.941 39.0096C153.157 39.5777 152.289 39.9712 151.336 40.1899C151.854 38.649 152.356 37.1025 152.842 35.5503C153.394 34.6382 153.72 33.6479 153.818 32.5794C154.95 29.1311 156.089 25.6854 157.237 22.2422Z",
    fill: "#2080B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6801 22.6484C26.6801 23.2318 26.6801 23.8151 26.6801 24.3984C25.4456 25.6736 24.211 26.9488 22.9766 28.224C22.9766 27.6543 22.9766 27.0845 22.9766 26.5147C24.2259 25.2383 25.4604 23.9495 26.6801 22.6484Z",
    fill: "#358E93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 22.6895C20.0004 23.5034 20.0004 24.3174 20.0004 25.1313C18.7807 26.4324 17.5462 27.7212 16.2969 28.9976C16.2969 28.1836 16.2969 27.3697 16.2969 26.5557C17.5462 25.2793 18.7807 23.9906 20.0004 22.6895Z",
    fill: "#3D9387"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6444 22.8105C65.0685 23.2752 65.4621 23.7635 65.8247 24.2757C65.3904 25.5644 64.9566 26.8532 64.5223 28.1419C64.1426 27.6671 63.7625 27.1923 63.3828 26.7175C63.8195 25.4209 64.2399 24.1185 64.6444 22.8105Z",
    fill: "#62AD49"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.72 23.0137C124.449 23.8406 124.177 24.6681 123.906 25.4962C123.717 25.53 123.527 25.5571 123.336 25.5776C123.615 24.7397 123.887 23.8986 124.15 23.0544C124.339 23.0289 124.529 23.0153 124.72 23.0137Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.72 23.0137C125.453 23.0137 126.185 23.0137 126.918 23.0137C126.655 23.8302 126.384 24.6441 126.104 25.4555C125.371 25.4544 124.638 25.468 123.906 25.4962C124.178 24.6681 124.449 23.8406 124.72 23.0137Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.916 23.0137C127.811 23.0137 128.706 23.0137 129.602 23.0137C129.36 23.833 129.102 24.6469 128.828 25.4555C127.92 25.4555 127.01 25.4555 126.102 25.4555C126.381 24.6441 126.652 23.8302 126.916 23.0137Z",
    fill: "#358E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.149 23.0547C123.886 23.8989 123.615 24.74 123.335 25.5779C121.699 25.7623 120.804 26.6712 120.649 28.3047C120.684 29.2005 121.05 29.9195 121.748 30.4617C121.436 31.4113 121.124 32.3609 120.812 33.3105C119.52 32.8257 118.537 31.9847 117.862 30.7872C117.726 30.4958 117.611 30.1974 117.516 29.8919C118.141 28.0564 118.752 26.2114 119.347 24.357C120.334 23.6729 121.432 23.2727 122.644 23.1564C123.143 23.0894 123.645 23.0555 124.149 23.0547Z",
    fill: "#3A928C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 23.1367C3.68005 23.8286 3.68005 24.5204 3.68005 25.2123C2.46039 26.5134 1.22589 27.8022 -0.0234375 29.0786C-0.0234375 28.3867 -0.0234375 27.6949 -0.0234375 27.003C1.19623 25.7019 2.43072 24.4131 3.68005 23.1367Z",
    fill: "#50A068"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8634 23.748C81.8495 24.6579 81.8699 25.5668 81.9244 26.4748C82.0156 27.735 82.497 28.8135 83.3692 29.7103C83.8751 30.1328 84.4448 30.4381 85.0785 30.626C84.7395 31.6294 84.4005 32.6332 84.061 33.6376C82.3306 33.2988 80.9399 32.4306 79.8895 31.0329C79.7923 30.8883 79.704 30.7391 79.625 30.5853C80.3397 28.2922 81.0856 26.0131 81.8634 23.748Z",
    fill: "#55A460"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.117 23.748C108.117 27.0581 108.117 30.3682 108.117 33.6783C107.018 33.6783 105.919 33.6783 104.82 33.6783C105.904 30.3594 107.003 27.0493 108.117 23.748Z",
    fill: "#43987D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4306 24.1133C54.4306 25.2121 54.4306 26.311 54.4306 27.4098C53.7237 29.4895 53.0318 31.5787 52.355 33.6772C52.0022 33.6772 51.6497 33.6772 51.2969 33.6772C52.3107 30.475 53.3554 27.287 54.4306 24.1133Z",
    fill: "#6AB23E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8961 24.1953C71.8961 24.7515 71.8961 25.3077 71.8961 25.8639C71.0264 28.4596 70.1717 31.0643 69.3321 33.6779C69.1071 33.7321 68.9443 33.6642 68.8438 33.4744C69.8299 30.3669 70.8473 27.2738 71.8961 24.1953Z",
    fill: "#5EAA52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.346 24.3574C118.751 26.2118 118.141 28.0568 117.515 29.8923C117.111 28.3163 117.335 26.8376 118.187 25.4563C118.503 25.0109 118.889 24.6446 119.346 24.3574Z",
    fill: "#3C9388"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6801 24.3984C26.6801 25.3209 26.6801 26.2434 26.6801 27.1659C25.4604 28.467 24.2259 29.7558 22.9766 31.0322C22.9766 30.0961 22.9766 29.1601 22.9766 28.224C24.211 26.9488 25.4456 25.6736 26.6801 24.3984Z",
    fill: "#338D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.388 25.0078C133.388 26.6629 133.388 28.3179 133.388 29.9729C132.966 31.1984 132.559 32.4329 132.167 33.6764C131.624 33.6764 131.082 33.6764 130.539 33.6764C131.473 30.7779 132.423 27.8884 133.388 25.0078Z",
    fill: "#318B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 25.1309C20.0004 26.0669 20.0004 27.003 20.0004 27.939C18.7659 29.2142 17.5314 30.4894 16.2969 31.7646C16.2969 30.8421 16.2969 29.9196 16.2969 28.9971C17.5462 27.7207 18.7807 26.432 20.0004 25.1309Z",
    fill: "#3A928C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68005 25.2129C3.68005 26.3796 3.68005 27.5462 3.68005 28.7129C2.56749 29.8526 1.46865 31.0057 0.38354 32.1722C0.195792 32.1735 0.0601336 32.0921 -0.0234375 31.928C-0.0234375 30.9784 -0.0234375 30.0288 -0.0234375 29.0792C1.22589 27.8028 2.46039 26.514 3.68005 25.2129Z",
    fill: "#4D9E6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8921 25.8633C71.8921 28.4679 71.8921 31.0726 71.8921 33.6772C71.0374 33.6772 70.1828 33.6772 69.3281 33.6772C70.1677 31.0636 71.0224 28.459 71.8921 25.8633Z",
    fill: "#5CA953"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.685 26.3105C142.18 27.4701 142.967 28.379 144.046 29.0373C143.72 30.0547 143.394 31.0722 143.069 32.0896C142.046 31.6601 141.151 31.0497 140.383 30.2582C140.817 28.9423 141.251 27.6264 141.685 26.3105Z",
    fill: "#2A87A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6801 27.166C26.6801 27.5187 26.6801 27.8714 26.6801 28.2242C25.4579 29.4735 24.2505 30.7351 23.058 32.009C23.0084 31.6913 22.9813 31.3657 22.9766 31.0323C24.2259 29.7559 25.4604 28.4671 26.6801 27.166Z",
    fill: "#318B9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.435 27.4102C54.435 29.4993 54.435 31.5885 54.435 33.6776C53.7431 33.6776 53.0512 33.6776 52.3594 33.6776C53.0362 31.579 53.728 29.4898 54.435 27.4102Z",
    fill: "#68B13F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0038 27.9395C20.0038 28.048 20.0038 28.1565 20.0038 28.265C18.787 29.5188 17.5797 30.7805 16.3817 32.0499C16.3138 31.9694 16.2867 31.8744 16.3003 31.765C17.5348 30.4899 18.7693 29.2146 20.0038 27.9395Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6768 28.2246C26.6768 29.0386 26.6768 29.8525 26.6768 30.6665C25.5913 31.7791 24.5196 32.905 23.4617 34.0444C23.2382 33.3884 23.1025 32.7101 23.0547 32.0095C24.2472 30.7355 25.4546 29.4739 26.6768 28.2246Z",
    fill: "#2F8A9E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0049 28.2637C20.0049 28.7385 20.0049 29.2133 20.0049 29.6881C19.1908 30.5022 18.3905 31.3297 17.6037 32.1706C17.2372 32.1774 16.8709 32.1706 16.5049 32.1503C16.4613 32.1156 16.4206 32.0817 16.3828 32.0486C17.5808 30.7791 18.7882 29.5175 20.0049 28.2637Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67933 28.7129C3.67933 28.9435 3.67933 29.1741 3.67933 29.4048C2.79867 30.3261 1.91688 31.2486 1.03398 32.1722C0.816923 32.1722 0.599866 32.1722 0.382812 32.1722C1.46792 31.0057 2.56676 29.8526 3.67933 28.7129Z",
    fill: "#4B9C71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.234 28.957C157.234 30.0016 157.234 31.0462 157.234 32.0908C157.171 33.5101 156.866 34.8802 156.318 36.2012C155.884 37.1369 155.281 37.944 154.507 38.6227C154.322 38.7625 154.132 38.8914 153.938 39.0094C155.029 35.6521 156.128 32.3014 157.234 28.957Z",
    fill: "#1F7FB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.047 29.0371C145.498 29.8306 147.044 30.1155 148.687 29.8918C148.369 30.8988 148.044 31.9027 147.71 32.9034C146.094 32.9914 144.548 32.7201 143.07 32.0894C143.396 31.072 143.721 30.0546 144.047 29.0371Z",
    fill: "#2785AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9397 29.3223C90.5107 30.6357 90.0903 31.9516 89.6781 33.2699C88.5768 33.7317 87.4234 33.9351 86.2188 33.8804C86.5305 32.8768 86.8426 31.8729 87.1548 30.8688C88.613 30.8129 89.8746 30.2973 90.9397 29.3223Z",
    fill: "#50A068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68441 29.4043C3.68441 29.6349 3.68441 29.8655 3.68441 30.0962C3.03462 30.7528 2.39025 31.4175 1.75127 32.0903C1.73238 32.1145 1.72559 32.1417 1.73092 32.1717C1.5003 32.1717 1.26968 32.1717 1.03906 32.1717C1.92197 31.2482 2.80376 30.3257 3.68441 29.4043Z",
    fill: "#4A9C72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0027 29.6895C20.0027 30.2592 20.0027 30.829 20.0027 31.3988C19.7597 31.6554 19.5155 31.9132 19.2702 32.172C18.714 32.172 18.1578 32.172 17.6016 32.172C18.3883 31.331 19.1887 30.5035 20.0027 29.6895Z",
    fill: "#368E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.298 29.7695C148.959 30.8012 148.62 31.8322 148.281 32.8626C148.092 32.8922 147.902 32.9058 147.711 32.9033C148.045 31.9025 148.37 30.8986 148.688 29.8916C148.892 29.8553 149.095 29.8146 149.298 29.7695Z",
    fill: "#2584AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.385 29.9746C133.385 31.2091 133.385 32.4436 133.385 33.6781C132.978 33.6781 132.571 33.6781 132.164 33.6781C132.556 32.4346 132.963 31.2001 133.385 29.9746Z",
    fill: "#308B9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68181 30.0957C3.68181 30.679 3.68181 31.2624 3.68181 31.8457C3.55972 31.9407 3.45119 32.0492 3.35623 32.1713C2.8136 32.1713 2.27096 32.1713 1.72832 32.1713C1.72299 32.1412 1.72977 32.1141 1.74867 32.0899C2.38764 31.417 3.03202 30.7523 3.68181 30.0957Z",
    fill: "#489B74"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.749 30.4629C121.891 30.568 122.04 30.663 122.196 30.7478C121.882 31.651 121.583 32.5599 121.301 33.4745C121.135 33.4284 120.972 33.3741 120.812 33.3117C121.125 32.3621 121.436 31.4125 121.749 30.4629Z",
    fill: "#38918E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0799 30.625C85.2395 30.6759 85.4023 30.7166 85.5683 30.7471C85.2509 31.7541 84.9253 32.758 84.5916 33.7587C84.4133 33.7231 84.2367 33.6824 84.0625 33.6366C84.4019 32.6323 84.7409 31.6284 85.0799 30.625Z",
    fill: "#53A364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6761 30.666C26.6875 31.0053 26.7011 31.3444 26.7168 31.6835C25.6981 32.7021 24.6942 33.7331 23.7051 34.7765C23.5841 34.5492 23.5027 34.305 23.4609 34.0439C24.5189 32.9046 25.5906 31.7786 26.6761 30.666Z",
    fill: "#2D89A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5705 30.748C86.0955 30.8352 86.6246 30.8759 87.1577 30.8701C86.8456 31.8743 86.5334 32.8781 86.2217 33.8818C85.6759 33.8803 85.1334 33.8396 84.5938 33.7597C84.9275 32.759 85.2531 31.7551 85.5705 30.748Z",
    fill: "#52A165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.192 30.748C122.823 31.0532 123.488 31.2296 124.186 31.2771C123.924 32.1478 123.652 33.016 123.372 33.8818C122.663 33.8291 121.971 33.6935 121.297 33.4748C121.579 32.5602 121.878 31.6513 122.192 30.748Z",
    fill: "#379090"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.038 30.9102C126.739 31.8462 126.441 32.7822 126.142 33.7183C125.795 33.7902 125.442 33.8377 125.084 33.8607C124.515 33.8811 123.945 33.8879 123.375 33.8811C123.655 33.0154 123.926 32.1471 124.189 31.2764C125.162 31.3257 126.112 31.2036 127.038 30.9102Z",
    fill: "#358E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.957,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9032 30.9922C95.9032 31.8875 95.9032 32.7829 95.9032 33.6782C95.6048 33.6782 95.3061 33.6782 95.0078 33.6782C95.2666 32.7658 95.5654 31.8704 95.9032 30.9922Z",
    fill: "#4B9D71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.978,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.006 31.3984C20.1214 32.0019 19.8772 32.2597 19.2734 32.1717C19.5188 31.9129 19.7629 31.6551 20.006 31.3984Z",
    fill: "#348E95"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7148 31.6836C26.7727 31.9626 26.827 32.2475 26.8775 32.5382C25.9142 33.5287 24.9646 34.5326 24.0287 35.5499C23.8879 35.3085 23.7794 35.0508 23.7031 34.7766C24.6922 33.7332 25.6961 32.7022 26.7148 31.6836Z",
    fill: "#2C88A3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68496 31.8457C3.65935 32.0341 3.55082 32.1426 3.35938 32.1713C3.45433 32.0492 3.56286 31.9407 3.68496 31.8457Z",
    fill: "#479B76"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8801 32.5371C27.024 33.0637 27.2003 33.5792 27.4092 34.0836C26.499 34.9937 25.6037 35.9162 24.7231 36.8511C24.4505 36.4417 24.2199 36.0076 24.0312 35.5487C24.9671 34.5315 25.9167 33.5276 26.8801 32.5371Z",
    fill: "#2A87A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.927,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2889 33.0264C41.0598 33.3234 40.8021 33.5947 40.5156 33.8403C40.5642 33.6335 40.6253 33.43 40.6988 33.2299C40.855 33.0353 41.052 32.9675 41.2889 33.0264Z",
    fill: "#1A7BC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.979,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2842 33.0254C41.5556 33.0932 41.8267 33.1611 42.0981 33.2289C41.2829 34.0846 40.4691 34.9392 39.6562 35.7928C40.007 35.1726 40.2919 34.5214 40.5109 33.8393C40.7974 33.5937 41.055 33.3224 41.2842 33.0254Z",
    fill: "#197BC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0992 33.2305C42.5176 33.3346 42.9384 33.4363 43.3608 33.5357C43.4841 33.5842 43.5521 33.6724 43.5643 33.8002C41.0138 36.4593 38.4769 39.1318 35.9539 41.8177C35.5897 41.8885 35.2235 41.943 34.855 41.9805C34.5023 41.9805 34.1496 41.9805 33.7969 41.9805C35.5333 40.1491 37.2697 38.3177 39.0062 36.4863C39.2244 36.2546 39.4414 36.024 39.6573 35.7944C40.4702 34.9408 41.284 34.0862 42.0992 33.2305Z",
    fill: "#177AC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5636 33.7988C43.0923 38.1574 40.705 40.8094 36.4008 41.7552C36.2525 41.7845 36.1032 41.8049 35.9531 41.8163C38.4762 39.1304 41.0131 36.4579 43.5636 33.7988Z",
    fill: "#1478C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4126 34.084C27.7587 34.7217 28.1657 35.3186 28.6335 35.8747C27.8074 36.7823 26.9663 37.6777 26.1103 38.5607C25.5732 38.0509 25.1119 37.4811 24.7266 36.8514C25.6071 35.9166 26.5025 34.9941 27.4126 34.084Z",
    fill: "#2785AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.733 36.1997C141.391 37.1843 141.066 38.1746 140.757 39.1706C140.294 38.9316 139.846 38.667 139.414 38.377C139.204 38.2187 139.014 38.0423 138.844 37.848C139.374 36.9838 139.91 36.1224 140.451 35.2637C140.852 35.6173 141.279 35.9293 141.733 36.1997Z",
    fill: "#2986A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.838 35.5488C152.352 37.101 151.85 38.6475 151.332 40.1884C150.458 40.4343 149.563 40.5768 148.646 40.6157C147.695 40.6515 146.745 40.6312 145.797 40.5546C146.095 39.5914 146.394 38.6283 146.692 37.6651C148.085 37.7714 149.442 37.6018 150.762 37.1564C151.61 36.8146 152.302 36.2788 152.838 35.5488Z",
    fill: "#2382B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6326 35.875C28.7005 35.9157 28.7547 35.9699 28.7954 36.0378C27.9552 36.9459 27.1142 37.8548 26.2722 38.7645C26.1872 38.7204 26.133 38.6526 26.1094 38.561C26.9654 37.678 27.8065 36.7826 28.6326 35.875Z",
    fill: "#2584AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7967 36.0371C29.3794 36.6063 30.0306 37.0811 30.7502 37.4615C30.7555 37.4916 30.7487 37.5187 30.7298 37.5429C29.859 38.434 28.9976 39.3293 28.1455 40.229C27.4629 39.818 26.8389 39.3296 26.2734 38.7639C27.1154 37.8541 27.9565 36.9452 28.7967 36.0371Z",
    fill: "#2382B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.727 36.2012C143.121 36.9464 144.6 37.4212 146.163 37.6256C145.867 38.5809 145.555 39.5305 145.227 40.4744C143.663 40.2786 142.171 39.8445 140.75 39.1721C141.059 38.1761 141.385 37.1858 141.727 36.2012Z",
    fill: "#2785AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0125 36.4863C37.2761 38.3177 35.5397 40.1491 33.8032 41.9805C33.654 41.9805 33.5048 41.9805 33.3556 41.9805C33.1928 41.9532 33.03 41.9264 32.8672 41.8991C34.1695 40.529 35.4718 39.1588 36.7742 37.7887C37.5774 37.4483 38.3235 37.0141 39.0125 36.4863Z",
    fill: "#197BC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7453 37.4629C31.0613 37.6209 31.3869 37.7566 31.722 37.8699C30.7982 38.8208 29.8893 39.7839 28.9953 40.7594C28.6885 40.6131 28.4036 40.4367 28.1406 40.2303C28.9927 39.3307 29.8541 38.4354 30.7249 37.5443C30.7438 37.5201 30.7506 37.493 30.7453 37.4629Z",
    fill: "#2080B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.163 37.6254C146.342 37.6171 146.518 37.6306 146.692 37.6661C146.393 38.6293 146.095 39.5925 145.796 40.5557C145.606 40.5285 145.417 40.5014 145.227 40.4743C145.555 39.5304 145.867 38.5808 146.163 37.6254Z",
    fill: "#2584AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7736 37.7871C35.4713 39.1573 34.169 40.5274 32.8666 41.8976C32.6667 41.9033 32.4767 41.876 32.2969 41.8162C33.4771 40.5681 34.6573 39.3201 35.8376 38.072C36.1514 37.9855 36.4634 37.8905 36.7736 37.7871Z",
    fill: "#1A7BC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7267 37.8691C32.1626 38.0222 32.6103 38.1307 33.0698 38.1947C32.102 39.2217 31.1253 40.2391 30.1395 41.247C29.7501 41.1066 29.3702 40.9438 29 40.7587C29.894 39.7832 30.8029 38.82 31.7267 37.8691Z",
    fill: "#1E7FB9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8305 38.0723C34.6503 39.3203 33.47 40.5684 32.2898 41.8165C31.5418 41.7212 30.8228 41.5312 30.1328 41.2467C31.1186 40.2388 32.0953 39.2213 33.063 38.1944C33.9927 38.3232 34.9152 38.2825 35.8305 38.0723Z",
    fill: "#1B7DBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_7845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.256,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3EPriceLabel);
export default __webpack_public_path__ + "static/media/L3ePriceLabel.b21b58787b7f0b78e0b0f0cf48c0258b.svg";
export { ForwardRef as ReactComponent };